import * as React from 'react';

import { RichHtmlEditor } from '@/components/rich-html-editor';

// =============================================================================
// cgu-editor.tsx — Éditeur WYSIWYG MAISON du corps HTML des CGU (0 dépendance tierce).
// =============================================================================
// Adaptateur MINCE au composant partagé `RichHtmlEditor` (V-CATALOG-UX : le WYSIWYG maison est
// mutualisé entre CGU (BC legal, §2.9) et catalogue (BC catalog, §2.4)). DBU §2.9 l.2030-2032 EXIGE
// un éditeur WYSIWYG intégré SANS dépendance à un éditeur EXTERNE (= construit en interne, pas
// « sans WYSIWYG ») avec les fonctions courantes (titres, listes, gras, italique, souligné, liens,
// tables). La barre d'outils balise directement — l'admin ne tape aucune balise. Le nettoyage
// autoritaire au write (sanitizer allowlist côté serveur, @jeko/shared-kernel) reste le choke point.

export interface CguEditorProps {
  /** Valeur courante du corps HTML (contrôlé). */
  readonly value: string;
  /** Notifie chaque frappe (le parent détient l'état — pas de localStorage). */
  readonly onChange: (next: string) => void;
  /** Désactive la saisie (ex. version non-Brouillon : lecture seule). */
  readonly disabled?: boolean;
  /** Id du label pour l'association ARIA (défaut interne si absent). */
  readonly id?: string;
}

export function CguEditor({
  value,
  onChange,
  disabled = false,
  id = 'cgu-editor-content',
}: CguEditorProps): React.JSX.Element {
  return (
    <RichHtmlEditor
      value={value}
      onChange={onChange}
      disabled={disabled}
      id={id}
      label="Contenu éditorial"
      hint="Utilisez la barre d'outils pour mettre en forme (titres, listes, gras, italique, souligné, liens, tables). Le contenu est nettoyé et sécurisé à l'enregistrement."
    />
  );
}
